/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artcraft_P1Inputs */

const en_home_artcraft_p1 = /** @type {(inputs: Home_Artcraft_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft is developed by the ArtCraft team as one of its Crafting Apps, a family of open-source creative and technical tools rebuilt in Rust. That is why you will often see the project called ArtCraft CADCraft. The source code is public on GitHub, and every new CADCraft build is published on the project's releases page.`)
};

/**
* | output |
* | --- |
* | "CADCraft is developed by the ArtCraft team as one of its Crafting Apps, a family of open-source creative and technical tools rebuilt in Rust. That is why you..." |
*
* @param {Home_Artcraft_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_artcraft_p1 = /** @type {((inputs?: Home_Artcraft_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artcraft_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_artcraft_p1(inputs)
});
export { home_artcraft_p1 as "home.artcraft.p1" }